var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"2","fill":"#000811"}}),_c('circle',{attrs:{"cx":"4","cy":"12","r":"2","fill":"#000811"}}),_c('circle',{attrs:{"cx":"20","cy":"12","r":"2","fill":"#000811"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }